module.exports = __webpack_public_path__ + "static/034.thumb-71d45a07af9c7dbd9fd865dac875da3e.jpg";